module.exports = __webpack_public_path__ + "static/media/Portrait-10210.e2e7ea9a.jpg";